import Marquee from "react-fast-marquee";

export const Ribbon = ({ dark = false }) => (
  <div
    data-testid="marquee-ribbon"
    className={`py-5 border-y ${dark ? "bg-[#2C3552] border-[#2C3552] text-[#FAFAF1]" : "bg-[#EEF2E3] border-[#DFE4D0] text-[#2C3552]"}`}
  >
    <Marquee speed={28} gradient={false} autoFill>
      <span className="font-serif-display italic text-lg sm:text-xl font-light mx-8">Paulina &amp; Louie</span>
      <span className="text-[10px] uppercase tracking-[0.35em] mx-8 text-[#C98A1B]">March 27, 2027</span>
      <span className="font-serif-display italic text-lg sm:text-xl font-light mx-8">Loews Coral Gables</span>
      <span className="text-[10px] uppercase tracking-[0.35em] mx-8 text-[#C98A1B]">Miami, Florida</span>
      <span className="font-serif-display text-lg mx-8 text-[#E15A70]">✦</span>
    </Marquee>
  </div>
);
